// The page's settings, read at run time from config.json next to index.html
// (autrik_codex T90 D4), so one build serves every environment. While the
// page ships inside the Flutter image (T90.1–T90.4) the Makefile writes the
// file from the same ../env/*.json the Flutter build reads.

export interface Config {
  appVersion: string;
  environment: string;
  kratosPublic: string; // https://autrik.com/api/.ory/kratos/public
  backend: string; // https://autrik.com/api
  wsHost: string; // wss://autrik.com/api/ws/
  videoHost: string; // RTMP base for liveshare; empty in every env today
  telemetryHostCloudApi: string; // ssl://autrikcloud.com:8884
  djiAppId: string;
  djiAppKey: string;
  djiAppLicense: string;
  logEncryptKey: string; // base64; empty = none
  sentryDsn: string; // empty = Sentry off
}

const required: (keyof Config)[] = [
  'kratosPublic',
  'backend',
  'telemetryHostCloudApi',
  'djiAppId',
  'djiAppKey',
  'djiAppLicense',
];

export async function loadConfig(fetchFn: typeof fetch = fetch): Promise<Config> {
  const res = await fetchFn(`${import.meta.env.BASE_URL}config.json`, { cache: 'no-store' });
  if (!res.ok) throw new Error(`config.json: HTTP ${res.status}`);
  const c = (await res.json()) as Partial<Config>;
  const missing = required.filter((k) => !c[k]);
  if (missing.length) throw new Error(`config.json lacks ${missing.join(', ')}`);
  return {
    appVersion: '',
    environment: '',
    wsHost: '',
    videoHost: '',
    logEncryptKey: '',
    sentryDsn: '',
    ...c,
  } as Config;
}
